<template>
  <div>
    <vggrid  :random="Math.floor(Math.random() * 999999)" :list="psuList" tableheight="400" flexname="" :cols="cols"
            :showfooter="false" :showPage="false" :resizable="true"
            @cellClick="cellClick" @cellDblClick="viewProject"
    >
    </vggrid>
    <div class="split-line"></div>
    <div v-if="pexpert">
      <!--<div>-->
        <!--<div>评审人[{{pexpert.pexpertname}}]的初审过程</div>-->
      <!--</div>-->
      <pqces-form-check-com-by-ex :projectid="projectid" :pexpert="pexpert" :pexpertid="pexpert.pexpertid"></pqces-form-check-com-by-ex>
    </div>
  </div>
</template>
<script>
  import request from '@/utils/request'
  import vggrid from '../../views/common/vggrid'
  import PqcesFormCheckComByEx from './pqcesFormCheckComByEx'
  import utils from '../../assets/js/utils'

  export default {
    name: 'pqcFormCheckSumIndex',
    components: {vggrid, PqcesFormCheckComByEx},
    props: {
      projectid: {},
      activeName: {}
    },
    data () {
      return {
        pexpert: '',
        project: {},
        psuList: [],
        pqcesList: [],
        pexpertInfo: {},
        pexertList: [],
        btnLoading: false,
        model: {},
        query: {
          total: 0,
          limit: 20,
          offset: 0
        },
        cols: [
          { field: 'comfullname', fieldtype: 'I', title: '供应商', calculExpr: '' }
        ]
      }
    },
    created () {
      // this.getModel()
    },
    activated () {
      this.pexpert = ''
    },
    mounted () {
      this.pexpert = ''
      this.getAllpfList()
    },
    watch: {
      activeName () {
        if(this.activeName === 'sc') {
          this.cols = [
            {field: 'comfullname', fieldtype: 'I', title: '供应商', calculExpr: ''}
          ]
          this.pexpert = ''
          this.getAllpfList()
        }
      }
    },
    methods: {
      async getModel () {
        let res = await request({
          method: 'get',
          url: 'expert/findProjectById',
          params: {projectid: this.projectid}
        })
        this.project = res
      },
      async getAllpfList () {
        let data = await request({
          method: 'get',
          url: 'expert/getAllpfList',
          params: {projectid: this.projectid}
        })
        this.psuList = data.psuList
        this.pqcesList = data.pqcesList
        this.pexertList = data.pexertList
        this.setCrossCols(data)
        this.totalScore(this.pqcesList)
      },
      async setCrossCols (res) {
        if (res.pexertList.length > 0) {
          for (let i = 0; i < res.pexertList.length; i++) {
            let item = res.pexertList[i]
            this.cols.push({
              // title: (item.pexpertname == null ? item.pexpertlogincode : item.pexpertname)+'',
              width: 135,
              slots: {
                default: 'default',
                default: ({row}) => {
                  return this.getCrossCheckResultDesc({pexpertid: item.pexpertid, psucomid: row.psucomid})
                },
                header: ({ column }) => {
                  return [
                    (item.pexpertname == null ? item.pexpertlogincode : item.pexpertname),
                    <span onClick={this.viewGc.bind(this,column,item)} style="color: #409EFF;padding-left:5px">查看过程</span>
                  ]
                }
              }
            })
          }
        }
        // this.cols.push({field: 'psupqcesresult',syscode:'psupqcesresult',fieldtype: 'C', title: '汇总结果', calculExpr: '',editRender: { name: 'select', options: []}})
        this.cols.push({
          title: '汇总结果',
          width: 80,
          slots: {
            default: 'default',
            default: ({row}) => {
              if (+row.psupqcesresult === 1) {
                return '通过'
              }
              if (+row.psupqcesresult === 2) {
                return '不通过'
              }
              else {
                return '无'
              }
            }
          }
        })
        this.cols.push({
          title: '意见',
          slots: {
            default: 'default',
            default: ({row}) => {
              return row.psupqcescdesc
            }
          }
        })
      },
      viewGc (col,item) {
        console.log(col, item)
        this.pexpert = item
      },
      getCrossCheckResultDesc (item) {
        let code = this.pqcesList.filter(v => +v.pqcesexpertid === +item.pexpertid && +v.pqcescomid === +item.psucomid)
        let i = code.length > 0 ? code[0].pqcesresultdesc : ''
        return i
      },
      totalScore (e) {
        let ty = 0, bty = 0
        for (let i = 0; i < this.psuList.length; i++) {
          for (let j = 0; j < this.pqcesList.length; j++) {
            if (this.psuList[i].psucomid === this.pqcesList[j].pqcescomid) {
              if (+this.pqcesList[j].pqcesresult == 1) {
                ty++
              }
              if (+this.pqcesList[j].pqcesresult == 2) {
                bty++
              }
            }
          }
          if (bty > 1) {
            this.psuList[i].psupqcesresult = '2'
          }
          else
            this.psuList[i].psupqcesresult = '1'
          ty = 0, bty = 0
        }
      },
      async getpsrecList () {
        let prsList = await request({
          method: 'get',
          url: 'expert/getpsrecList',
          params: {psprojectid: this.projectid}
        })

        if (prsList.length > 0) {
          this.psuList.forEach(e => {
            e.psdesc = prsList.filter(v => +v.pscomid === +e.psucomid && +v.psprojectid === +e.psuprojectid)[0].psdesc
          })
        }
      },
      async cellClick (row) {
        this.model = row
      },
      async viewProject (row) {
        this.model = row
      }
    }
  }
</script>

<style lang="scss" scoped>
  .btn {
    display: flex;
    justify-content: center;
    width: 100%;
    margin: 30px 0;
  }
</style>